// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__HZyhu","center":"sidebar_center__QUElc","verticalContainer":"sidebar_verticalContainer__BQN0o","item":"sidebar_item__6GA0F"};